import {
  GET_ALL_REPORT_CONFIGURATIONS_REQUEST,
  GET_ALL_REPORT_CONFIGURATIONS_SUCCESS,
  GET_ALL_REPORT_CONFIGURATIONS_FAIL,
  CREATE_REPORT_CONFIGURATION_REQUEST,
  CREATE_REPORT_CONFIGURATION_SUCCESS,
  CREATE_REPORT_CONFIGURATION_FAIL,
  UPDATE_REPORT_CONFIGURATION_REQUEST,
  UPDATE_REPORT_CONFIGURATION_SUCCESS,
  UPDATE_REPORT_CONFIGURATION_FAIL,
  DELETE_REPORT_CONFIGURATION_REQUEST,
  DELETE_REPORT_CONFIGURATION_SUCCESS,
  DELETE_REPORT_CONFIGURATION_FAIL,
  GET_DASHBOARD_REPORTS_REQUEST,
  GET_DASHBOARD_REPORTS_SUCCESS,
  GET_DASHBOARD_REPORTS_FAIL,
  EXPORT_REPORT_REQUEST,
  EXPORT_REPORT_SUCCESS,
  EXPORT_REPORT_FAIL,
} from '../actions/reportActions';

const safeArray = (value) => (Array.isArray(value) ? value : []);

const initialState = {
  list: [],
  current: null,
  dashboardReports: [],
  reportsLoading: false,
  reportSaveLoading: false,
  reportDashboardLoading: false,
  reportExportLoading: false,
  reportsError: null,
  reportSaveError: null,
  reportDashboardError: null,
  reportExportError: null,
};

export default function reportReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_REPORT_CONFIGURATIONS_REQUEST:
      return {
        ...state,
        reportsLoading: true,
        reportsError: null,
      };

    case GET_ALL_REPORT_CONFIGURATIONS_SUCCESS:
      return {
        ...state,
        list: safeArray(action.payload),
        reportsLoading: false,
        reportsError: null,
      };

    case GET_ALL_REPORT_CONFIGURATIONS_FAIL:
      return {
        ...state,
        list: [],
        reportsLoading: false,
        reportsError: action.error,
      };

    case CREATE_REPORT_CONFIGURATION_REQUEST:
    case UPDATE_REPORT_CONFIGURATION_REQUEST:
    case DELETE_REPORT_CONFIGURATION_REQUEST:
      return {
        ...state,
        reportSaveLoading: true,
        reportSaveError: null,
      };

    case CREATE_REPORT_CONFIGURATION_SUCCESS:
      return {
        ...state,
        list: action.payload ? [...safeArray(state.list), action.payload] : safeArray(state.list),
        current: action.payload || null,
        reportSaveLoading: false,
        reportSaveError: null,
      };

    case UPDATE_REPORT_CONFIGURATION_SUCCESS:
      return {
        ...state,
        list: safeArray(state.list).map((item) => (item?.id === action.payload?.id ? action.payload : item)),
        dashboardReports: safeArray(state.dashboardReports).map((item) => (item?.id === action.payload?.id ? action.payload : item)),
        current: action.payload || null,
        reportSaveLoading: false,
        reportSaveError: null,
      };

    case DELETE_REPORT_CONFIGURATION_SUCCESS:
      return {
        ...state,
        list: safeArray(state.list).filter((item) => item?.id !== action.payload),
        dashboardReports: safeArray(state.dashboardReports).filter((item) => item?.id !== action.payload),
        current: state.current?.id === action.payload ? null : state.current,
        reportSaveLoading: false,
        reportSaveError: null,
      };

    case CREATE_REPORT_CONFIGURATION_FAIL:
    case UPDATE_REPORT_CONFIGURATION_FAIL:
    case DELETE_REPORT_CONFIGURATION_FAIL:
      return {
        ...state,
        reportSaveLoading: false,
        reportSaveError: action.error,
      };

    case GET_DASHBOARD_REPORTS_REQUEST:
      return {
        ...state,
        dashboardReports: [],
        reportDashboardLoading: true,
        reportDashboardError: null,
      };

    case GET_DASHBOARD_REPORTS_SUCCESS:
      return {
        ...state,
        dashboardReports: safeArray(action.payload),
        reportDashboardLoading: false,
        reportDashboardError: null,
      };

    case GET_DASHBOARD_REPORTS_FAIL:
      return {
        ...state,
        dashboardReports: [],
        reportDashboardLoading: false,
        reportDashboardError: action.error,
      };

    case EXPORT_REPORT_REQUEST:
      return {
        ...state,
        reportExportLoading: true,
        reportExportError: null,
      };

    case EXPORT_REPORT_SUCCESS:
      return {
        ...state,
        reportExportLoading: false,
      };

    case EXPORT_REPORT_FAIL:
      return {
        ...state,
        reportExportLoading: false,
        reportExportError: action.error,
      };

    default:
      return state;
  }
}
